module.exports = __webpack_public_path__ + "img/slider_2.69408fd7.jpg";